import { useState, type ChangeEvent } from 'react';

type TextAreaType = {
	placeholder?: string;
	name: string;
	id: string;
	autoComplete?: string;
	required: boolean;
	label: string;
	onChange: React.ChangeEventHandler<HTMLTextAreaElement>;
	htmlFor: string;
	ariaLabel: string;
	disabled?: boolean;
	className?: string;
	description?: string | null;
};

export default function TextArea(props: TextAreaType) {
	const {
		name,
		id,
		required,
		label,
		htmlFor,
		onChange,
		ariaLabel,
		disabled = false,
		className = '',
		description,
		placeholder,
	} = props;

	const [isActive, setActive] = useState(false);

	const middleWareOnChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
		onChange(e);
		setActive(e.target.value ? true : false);
	};

	const inputTypeModel = {
		id: id,
		name: name,
		required: required,
		onChange: middleWareOnChange,
		'aria-label': ariaLabel,
		disabled: disabled,
		className: className,
		description: description,
		placeholder: placeholder,
	};

	return (
		<div className={`relative my-5 w-full min-w-[200px] ${className}`}>
			<textarea
				{...inputTypeModel}
				rows={10}
				cols={50}
				className='peer w-full resize-y rounded-minos-form-input border-2 border-minos-form-input-border-color bg-minos-form-input-bg-color py-4 pl-4 pr-2.5 text-base text-minos-form-input-color outline outline-0 transition-all placeholder:opacity-0 focus:border-2 focus:border-minos-form-secondary-color focus:outline-0 focus:placeholder:text-minos-blue_dark-200 focus:placeholder:opacity-100 disabled:cursor-not-allowed disabled:bg-minos-blue_dark-100'
			/>
			<label
				htmlFor={htmlFor}
				className={`pointer-events-none absolute left-4 top-2.5 !overflow-visible truncate text-base text-minos-form-input-color transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:text-minos-form-input-color peer-focus:-top-3 peer-focus:rounded-md peer-focus:bg-minos-form-input-bg-color peer-focus:px-1.5 peer-focus:py-1 peer-focus:text-[11px] peer-focus:font-semibold peer-focus:leading-tight peer-focus:text-minos-form-secondary-color peer-disabled:text-transparent ${
					required &&
					'after:ml-0.5 after:font-semibold after:text-minos-form-require-color after:content-["*"]'
				} ${
					isActive &&
					'!-top-3 rounded-md bg-minos-form-input-bg-color px-1.5 py-1 !text-[11px] leading-tight text-minos-form-input-color'
				}`}
			>
				{label}
			</label>

			{description ? (
				<p className='minos-form-content-font-style text-base tablet:minos-form-content-font-style'>
					{description}
				</p>
			) : null}
		</div>
	);
}
